import z, { ZodType } from "zod";
import {
  RetentionTypeEnum,
  StandardAbutmentTypeEnum,
  type AbutmentCharacteristics,
  type CustomAbutmentCharacteristics,
  type ImplantCharacteristics,
  type ImplantedItemCharacteristics,
  type ReferencedImplantCharacteristics,
  type StandardAbutmentCharacteristics,
  type UnreferencedImplantCharacteristics,
} from "./implants.types";

export const implantedItemCharacteristicsSchema: ZodType<ImplantedItemCharacteristics> =
  z.object({
    retentionType: z.enum(Object.values(RetentionTypeEnum)),
  });

export const standardAbutmentCharacteristicsSchema: ZodType<StandardAbutmentCharacteristics> =
  z.object({
    abutmentType: z.enum(Object.values(StandardAbutmentTypeEnum)),
    abutmentPreferences: z.string().nonempty().optional(),
  });

export const customAbutmentCharacteristicsSchema: ZodType<CustomAbutmentCharacteristics> =
  z.object({
    abutmentType: z.literal("CUSTOM"),
  });

export const abutmentCharacteristicsSchema: ZodType<AbutmentCharacteristics> =
  z.union([
    standardAbutmentCharacteristicsSchema,
    customAbutmentCharacteristicsSchema,
  ]);

const baseImplantCharacteristicsSchema = z.object({
  implantPlatform: z.string().nonempty(),
  scanBodyReference: z.string().nonempty(),
});

export const referencedImplantCharacteristicsSchema: ZodType<ReferencedImplantCharacteristics> =
  baseImplantCharacteristicsSchema.extend({
    implantReferenceId: z.string().nonempty(),
  });

export const unreferencedImplantCharacteristicsSchema: ZodType<UnreferencedImplantCharacteristics> =
  baseImplantCharacteristicsSchema.extend({
    implantBrand: z.string().nonempty(),
    implantSystem: z.string().nonempty(),
  });

export const implantCharacteristicsSchema: ZodType<ImplantCharacteristics> =
  z.union([
    referencedImplantCharacteristicsSchema,
    unreferencedImplantCharacteristicsSchema,
  ]);
